<template>
    <div class="wrap">
        <!-- 헤더 -->
        <main-header></main-header>

        <!-- 메인 -->
        <v-main class="main">
            <slot />
        </v-main>

        <!-- 푸터 -->
        <main-footer><!-- 기업정보 --></main-footer>
    </div>
</template>

<script>
import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
export default {
    props: {
        isMain: { type: Boolean, default: true },
    },
    components: {
        MainHeader,
        MainFooter,
    },
};
</script>
